export const Types = {
  START_ADD_STEPS: 'START_ADD_STEPS',
  END_ADD_STEPS: 'END_ADD_STEPS',
  START_DELETE_STEPS: 'START_DELETE_STEPS',
  END_DELETE_STEPS: 'END_DELETE_STEPS',
  TOGGLE_PUBLISH_STEP: 'TOGGLE_PUBLISH_STEP',
  START_STEP_NUMBERS_SAVE: 'START_STEP_NUMBERS_SAVE',
  END_STEP_NUMBERS_SAVE: 'END_STEP_NUMBERS_SAVE'
};

export const startAddStepsAction = platform => ({
  type: Types.START_ADD_STEPS,
  platform
});

export const endAddStepsAction = platform => ({
  type: Types.END_ADD_STEPS,
  platform
});

export const startDeleteStepsAction = platform => ({
  type: Types.START_DELETE_STEPS,
  platform
});

export const endDeleteStepsAction = platform => ({
  type: Types.END_DELETE_STEPS,
  platform
});


export const togglePublishStepAction = (stepResourceId, publishStep, breakResourceId, stepIndex) => ({
  type: Types.TOGGLE_PUBLISH_STEP,
  stepResourceId,
  publishStep,
  breakResourceId,
  stepIndex
});

export const startStepNumbersSaveAction = (
  breakResourceId,
  stepNumbersAndResourceIds // [{resourceId, stepNumber}]
) => ({
  type: Types.START_STEP_NUMBERS_SAVE,
  breakResourceId,
  stepNumbersAndResourceIds
});

export const endStepNumbersSaveAction = () => ({
  type: Types.END_STEP_NUMBERS_SAVE
});



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/actions.js